import { KnowledgeDetailTypes } from '../actions/knowledgeDetailAction';

const defaultState = {
  kbDetail: {},
  isLoading: true,
  kbUsefulPercentage: 0,
  kbUseful: '',
  rating: -1,
  lastComment: {},
  commentsData: [],
  reloadComments: false,
  mostViewedArticles: [],
  allAttachment: [],
  isLoadingFeedback: false,
  isOpenFeedbackDialog: false,
  isLoadingComment: false,
};

const knowledgeDetailReducer = (state = defaultState, action: any) => {
  const { type, kbDetail, lastComment, commentsData, kbUsefulPercentage, kbUseful, rating, usefulChange, ratingChange, mostViewedArticles, isLoading, allAttachment, isLoadingFeedback, isOpenFeedbackDialog, isLoadingComment } = action;
  switch (type) {
    case KnowledgeDetailTypes.FETCH_KB_DETAIL:
      return {
        ...state,
        isLoading: true,
      };
    case KnowledgeDetailTypes.FETCH_KB_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        kbDetail: kbDetail || {},
      };
    case KnowledgeDetailTypes.FETCH_LATEST_COMMENT_SUCCESS:
      return {
        ...state,
        lastComment: lastComment || {},
      };
    case KnowledgeDetailTypes.FETCH_COMMENTS_DATA_SUCCESS:
      return {
        ...state,
        commentsData:
          !!commentsData?.data && commentsData?.data.length > 0
            ? commentsData.data
            : [],
        totalCountPages: !!commentsData?.totalCount
          ? commentsData.totalCount
          : 0,
      };
    case KnowledgeDetailTypes.RELOAD_COMMENTS_DATA_SUCCESS:
      return {
        ...state,
        reloadComments: !state.reloadComments,
        isLoading: false,
      };
    case KnowledgeDetailTypes.GET_KB_USEFUL_PERCENTAGE_SUCCESS:
      return {
        ...state,
        kbUsefulPercentage
      };
    
    case KnowledgeDetailTypes.GET_USEFUL_BY_USER_SUCCESS:
      return {
        ...state,
        kbUseful
      };

    case KnowledgeDetailTypes.FETCH_RATINGS_SUCCESS:
      return {
        ...state,
        rating
      };

    case KnowledgeDetailTypes.UPDATE_USEFUL_CHANGE_SUCCESS:
      return {
        ...state,
        kbUseful: usefulChange
      };

    case KnowledgeDetailTypes.UPDATE_RATING_CHANGE_SUCCESS:
      return {
        ...state,
        rating: ratingChange
      };
    case KnowledgeDetailTypes.GET_MOST_VIEWED_ARTICLES_SUCCESS:
      return {
        ...state,
        mostViewedArticles
      };
    case KnowledgeDetailTypes.RESET:
      return {
        ...defaultState,
      };
    case KnowledgeDetailTypes.SET_LOADING_KB: {
      return {
          ...state,
          isLoading,
        };
      }
    case KnowledgeDetailTypes.SET_LOADING_FEEDBACK: 
      return {
        ...state,
        isLoadingFeedback,
      };
    case KnowledgeDetailTypes.SET_OPEN_FEEDBACK_DIALOG: 
      return {
        ...state,
        isOpenFeedbackDialog,
      };
    case KnowledgeDetailTypes.FETCH_ALL_ATTACHMENT_SUCCESS:
      return {
        ...state,
        allAttachment
      };
    case KnowledgeDetailTypes.SET_LOADING_COMMENT:
      return {
        ...state,
        isLoadingComment,
      };
  }

  return state;
};

export default knowledgeDetailReducer;
